import { _api } from './apiAxios';

export function login(email, password, isClerk, macAddress) {
  const token = localStorage.getItem('epos_token');
  return _api.post(
    '/login',
    {
      Email: email,
      Password: password,
      IsClerk: isClerk,
      MacAddress: macAddress,
    },
    { headers: { 'epos-token': token } },
  );
}

export function register(
  email,
  password,
  passwordRepeat,
  firstName,
  lastName,
  promoCode,
  hearAbout,
  hearAboutDetail,
  refererSignup,
  signupDeviceType,
  signupDeviceAgent,
  remoteIp,
  language,
  requestDomain,
  agreeTos,
  doNotEmail,
  country,
  BirthDay,
  phone_number,
  AffToken,
) {
  return _api.post('/register', {
    Email: email,
    Password: password,
    FirstName: firstName,
    LastName: lastName,
    PromoCode: promoCode,
    RefererSignup: refererSignup,
    SignupDeviceType: signupDeviceType,
    SignupDeviceAgent: signupDeviceAgent,
    RemoteIp: remoteIp,
    Language: language,
    HearAbout: hearAboutDetail,
    HearAboutDetail: hearAbout,
    agreeTos: agreeTos,
    DoNotEmail: doNotEmail,
    RequestDomain: requestDomain,
    MobilePhone: phone_number,
    DateOfBirth: BirthDay,
    Country: country ? country.toUpperCase() : '',
    AffToken: AffToken,
  });
}

export async function getCountries(book_id, languageKey) {
  let languageId = 1;
  try {
    let res = await getLanguages().then(res => {
      languageId = res.data.Data.find(item => item.code == languageKey).id;
    });
  } catch (err) {}
  return _api.get('/dictionary/get_countries_by_book_id?language_id=' + languageId);
}

export function getLanguages() {
  return _api.get('/dictionary/get_languages');
}

export function getStates(iso2) {
  return _api.get('/dictionary/states/' + iso2);
}

export function getCreditCards() {
  return _api.get('/deposit/creditcards');
}

export function getOpenPayClient() {
  return _api.get('/deposit/openpay/client');
}

export function getRules() {
  return _api.get('/deposit/rules');
}

export function getGlobalLimits() {
  return _api.get('/rules/global');
}

export function resetGlobalLimits() {
  return _api.get('/rules/global/reset');
}

export function changeGlobalLimits(param) {
  return _api.get(`/rules/global/change${param}`);
}

export function getPaymentRules() {
  return _api.get('/deposit/getpaymentrules');
}

export function getPayoutPaymentRules() {
  return _api.get('/payout/getpaymentrules');
}
export function refreshPlayerAuthentication() {
  return _api.get('/accountverification/refresh');
}

export function getFailedTransactionResult() {
  return _api.get('/cashier/cards/credit-card-transaction');
}

export function getSuccessTransactionResult() {
  return _api.get('/cashier/cards/deposit-success');
}

export function getAllCryptoWallets() {
  return _api.get('/deposit/allcryptowallets');
}

export function createCryptoWallet(currencyType) {
  return _api.get('/deposit/wallets/create?currencyType=' + currencyType);
}

export function createDepositForRegisteredCustomer(formData) {
  return _api.post('/customers/deposit', formData);
}

export function getAchBankAccounts() {
  return _api.get('/deposit/achbankaccounts');
}

export function hasDocumentIdApproved() {
  return _api.get('/deposit/hasdocumentidapproved');
}

export function getAchProcessorName(amount) {
  return _api.get('/deposit/ach/processor?amount=' + amount);
}

export function processAchDeposit(formData) {
  return _api.post('/deposit/ach/process', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
export function getPromotions() {
  return _api.get('/promotion');
}

export function gettingRedeemCodeCorrectless({ redeemCode = null }) {
  return _api.get(`/promotion/by_promo_code/${redeemCode}`);
}

export function getCurrentPromotion() {
  return _api.get('/promotion/current');
}
export function getAddPromotion(promoCode) {
  return _api.get(`/promotion/addpromocode?promoCode=${promoCode}`);
}

export function getRemovePromotion() {
  return _api.get('/promotion/current/remove');
}

export function processMoneyGramDeposit(formData) {
  return _api.post('/deposit/moneygram', formData);
}

export function processCreditCardDeposit(formData) {
  return _api.post('/deposit/creditcard', formData);
}

export function searchBlockElements(formData) {
  return _api.post('/negative/blockelements', formData);
}

export function getCurrentPromoCode() {
  return _api.get('/deposit/promotion/getcurrentpromocode');
}

export function addPromoCode(promoCode) {
  return _api.get('/deposit/promotion/addpromocode?promoCode=' + promoCode);
}

export function removeCurrentPromoCode() {
  return _api.get('/deposit/promotion/removecurrentpromocode');
}

export function getPayoutMethods() {
  return _api.get('/payout/payoutmethods');
}

export function getPayoutBankAccounts(method) {
  return _api.get('/payout/getpaymentbankaccounts?method=' + method);
}

export function getPendingPayouts() {
  return _api.get('/payout/pendings');
}

export function getRolloverCheck() {
  return _api.get('/payout/rollover');
}

export function getStoredWireTransfers() {
  return _api.get('/payout/stored/wiretransfer');
}

export function getStoredEcheckPayout() {
  return _api.get('/payout/stored/echeck');
}
export function getStoredEcheck() {
  return _api.get('/deposit/stored/echeck');
}
export function getLastPayoutDetails() {
  return _api.get('payout/lastpayoutdetail');
}

export function getHelperDataSpei() {
  return _api.get('/payout/get_helper_data_spei');
}
export function postPayoutSpei(payload) {
  return _api.post('/payout/spei', payload);
}

export function getPayoutFee(channel, method, amount) {
  return _api.get(`/payout/payoutfee?pkMschannel=${channel}&pkPayoutMethod=${method}&amount=${amount}`);
}

export function postPayoutTodito(payload) {
  return _api.post('/payout/todito', payload);
}

export function postPayoutAll4Pay(payload) {
  return _api.post('/payout/all4pay', payload);
}

export function getOperationTypesAll4Pay() {
  return _api.get('/deposit/all4payoperationtypes');
}

export function postPayoutVcreditos(payload) {
  return _api.post('/payout/vcreditos', payload);
}

export function getCancelPayout(id) {
  return _api.get(`/payout/cancel?id=${id}`);
}

export function getCryptoCurrencyPayoutVerificationCode(payload) {
  return _api.get(`/payout/getverifycode?payoutMethod=${payload.method}&amount=${payload.amount}`);
}

export function getSmsVerificationCode(phoneNumber) {
  return _api.get(`/accountverification/sms?phone=${phoneNumber}`);
}
export function verifySmsVerificationCode(formData) {
  return _api.get(
    `/accountverification/sms/verify?phone=${formData.phoneNumber}&verification_code=${formData.verifyCode}`,
  );
}

export function postCryptoPayout(formData) {
  return _api.post('/payout/crypto', formData);
}

export function getOnlineBankingAccounts() {
  return _api.get(`/payout/getonlinebankingaccounts`);
}

export function getSkrillAccounts() {
  return _api.get('/payout/stored/skrill');
}

export function getNetellerAccounts() {
  return _api.get('/payout/stored/neteller');
}

export function getOnlineBankingBanks() {
  return _api.get(`/payout/getonlinebankingbanks`);
}

export function getBanksMethodCountry(pkPayoutMethod, country) {
  return _api.get(`/payout/getonlinebankingbanksmethod?pkPayoutMethod=${pkPayoutMethod}&country=${country}`);
}

export function getPayrAccounts() {
  return _api.get('/payout/stored/payr');
}

export function postPayrPayout(formData) {
  return _api.post('/payout/payr', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function postWireTransferPayout(formData) {
  return _api.post('/payout/wiretransfer', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function postOnlineBankingPayout(formData) {
  return _api.post('/payout/onlinebanking', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
export function postSkrillPayout(formData) {
  return _api.post('/payout/skrill', formData);
}
export function postNetellerPayout(formData) {
  return _api.post('/payout/skrill', formData);
}

export function postEcheckPayout(formData) {
  return _api.post('/payout/echeck', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function getHistory(from, to) {
  return _api.post('/history', {
    From: from,
    To: to,
  });
}

export function getHistoryWithPagination({ startDate, endDate, category, pageSize, pageIndex,lineStyle }) {
  return _api.post('/history/detail', {
    startDate,
    endDate,
    category,
    pageSize,
    pageIndex,
    lineStyle
  });
}

export function getHistorySummary({ startDate, endDate }) {
  return _api.post('/history/summary', {
    startDate,
    endDate,
  });
}

export function getOpenBets(lineStyle) {
  return _api.get('/player/history/openbetsv2?lineStyle=' + lineStyle);
}

export function changeLineStyle(lineStyle) {
  return _api.get('/player/change-line-style?lineStyle=' + lineStyle);
}
export function changeLanguage(language) {
  return _api.post('/player/change-player-language', language);
}
export function changeTimezone(timezone) {
  return _api.post('/player/change-player-time-zone', timezone);
}

export function createReferral(invites) {
  return _api.post('/refer', invites);
}

export function contact(formData) {
  return _api.post('/communication/contact-us', formData);
}

export function clerkWalletDeposit(formData) {
  return _api.post('/wallets/deposit', formData);
}

export function clerkWalletPayout(formData) {
  return _api.post('/wallets/payout', formData);
}

export function clerkWalletRecover(formData) {
  return _api.post('/wallets/recover', formData);
}

export function clerkWalletDisable(formData) {
  return _api.post('/wallets/disable', formData);
}

export function clerkSearchPlayer(formData) {
  return _api.post('/clerk/player/search', formData);
}

export function clerkSearchWager(formData) {
  return _api.post('/clerk/wager/search', formData);
}

export function registeredCustomerDeposit(formData) {
  return _api.post('/customers/deposit', formData);
}

export function clerkRegisteredCustomerPayout(formData) {
  return _api.post('/customers/payout', formData);
}

export function getPlayerAccountPayouts(formData) {
  return _api.post('clerk/getplayeraccountpayouts', formData);
}

export function clerkLoyaltyCardSearch(formData) {
  return _api.post('/clerk/loyalty-card/search', formData);
}

export function clerkLoyaltyCardInsert(formData) {
  return _api.post('/clerk/loyalty-card/insert', formData);
}

export function getDepositTicketBalance(formData) {
  return _api.post('/player/balance', formData);
}

export function getDepositTicketOpenBets(formData) {
  return _api.get('/clerk/getscandetails?scanCode=' + formData.scan_code);
}

export function getScanDetails(scanCode) {
  return _api.get(`/clerk/getscandetails?scanCode=${scanCode}`);
}

export function getDepositScanBarcode(formData) {
  return _api.post('/player/scan_barcode', formData);
}

export function getDepositTicketGradedBets(formData) {
  return _api.post('/player/gradedbets', formData);
}

export function getDepositTicketAllBets(formData) {
  return _api.post('/player/allbets', formData);
}

export function getAccountVerificationStatus() {
  return _api.get('/accountverification/status');
}

export function updateRequiredData(formData) {
  return _api.post('/accountverification/set_required_data', formData);
}
export function postAccountVerificationDocuments(formData) {
  return _api.post('/accountverification/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
export function getAvailableDepositMethods() {
  return _api.get('/deposit/methods/avaliable');
}
export function getDepositOnlineBankingBanks(param) {
  return _api.get(`/deposit/onlinebanking/banks?processor=${param}`);
}
export function getOnlineBankingProcessors() {
  return _api.get('/deposit/onlinebanking/processors');
}
export function getCheckRestricted() {
  return _api.get('/deposit/check_restricted');
}
export function getCheckQuickBit() {
  return _api.get('/deposit/quickbit_check');
}
export function getCheckNeteller() {
  return _api.get('/deposit/neteller_check');
}
export function getCheckSkrill() {
  return _api.get('/deposit/skrill_check');
}
export function processAstropayDeposit(formData) {
  return _api.post('/deposit/astropay/process', formData);
}
export function processQuickBitDeposit(amount) {
  return _api.get(`/deposit/qıickbit/process?amount=${amount}`);
}
export function processorGamecashDeposit() {
  return _api.get(`/deposit/gamecash/network`);
}
export function optionGamecashDeposit(processor) {
  return _api.get(`/deposit/gamecash/options?processor=${processor}`);
}
export function processGamecashDeposit(payload) {
  return _api.post(`/deposit/gamecash/process`, payload);
}
export function processorEwalletDeposit() {
  return _api.get(`/deposit/ewallet/processors`);
}
export function processEwalletDeposit(payload) {
  var processor = payload.processor;
  var amount = payload.amount;
  delete payload.gtm_event_name;
  delete payload.amount;
  delete payload.processor;

  const isMobile = /iphone|ipod|ipad|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(
    navigator.userAgent.toLowerCase(),
  );
  const deviceType = isMobile ? 'M' : 'D';

  return _api.get(`/deposit/ewallet/process/${processor}/${amount}`, {
    params: payload,
    headers: { 'Device-Type': deviceType },
  });
}
export function processNetellerDeposit(formData) {
  const res = {
    account_code: formData.neteller_account,
    secure_id: formData.neteller_code,
    amount: formData.amount,
  };
  return _api.get(
    `/deposit/neteller/process?account_code=${res.account_code}&secure_id=${res.secure_id}&amount=${res.amount}`,
  );
}
export function processSkrillDeposit(formData) {
  return _api.get(`/deposit/skrill/process?amount=${formData.amount}`);
}
export function transactionsSearch(formData) {
  return _api.post('/transactions/search', formData);
}
export function depositWalletSearch(formData) {
  return _api.post('/wallets/search', formData);
}
export function sendPasswordResetEmail(email) {
  return _api.get('/send-password-reset-email?email=' + email);
}
export function changePassword(formData) {
  return _api.post('/player/update-password', formData);
}
export function resetPassword(password_token, password) {
  return _api.get('/reset-password?password_token=' + password_token + '&password=' + password);
}

export function getWagerLimits() {
  return _api.get('/player/get-wager-preferences');
}
export function postWagerLimits(data) {
  return _api.post('/player/update-wager-preferences', data);
}

export function createPDF(data) {
  data.htmlBody = '<style>html,body {font-size: 25px !important; }</style>' + data.htmlBody;
  return _api
    .post('/deposit/createpdf', data, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/pdf',
      },
    })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', data.instructionsStoreName + '.pdf'); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
}

export function getEwalletAccount(key) {
  return _api.get('/payout/getewalletaccount?ewallet=' + key);
}

export function getClerkPayouts(payload) {
  return _api.get('/clerk/getpayouts', { params: payload });
}

export function checkRollover(payload) {
  return _api.post('payout/rollover_check', payload);
}

export function checkPixUserDocument() {
  return _api.get('/deposit/pixAccounts');
}

export function processPixDeposit(userDocument, amount) {
  return _api.get('/deposit/pix/process?accountCode=' + userDocument + '&amount=' + amount);
}
